export class UserUpdateModel {
    id: string;
    userName: string;
    fullName: string;
    securityProfileId: number;
    organizationLevelIds: string[];
    roleId: string;
}
